/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Rate_EmbedInputs */

const en_usage_rate_embed = /** @type {(inputs: Usage_Rate_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$2.00 / job`)
};

const fr_usage_rate_embed = /** @type {(inputs: Usage_Rate_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2,00 $ / emploi`)
};

const de_usage_rate_embed = /** @type {(inputs: Usage_Rate_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2,00 € / Auftrag`)
};

const it_usage_rate_embed = /** @type {(inputs: Usage_Rate_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$2,00 / lavoro`)
};

const ru_usage_rate_embed = /** @type {(inputs: Usage_Rate_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2,00 доллара за работу`)
};

const es_usage_rate_embed = /** @type {(inputs: Usage_Rate_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$2.00 / trabajo`)
};

const zh_cn2_usage_rate_embed = /** @type {(inputs: Usage_Rate_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每份工作 2.00 美元`)
};

const ja_usage_rate_embed = /** @type {(inputs: Usage_Rate_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2.00ドル/仕事`)
};

const hi_usage_rate_embed = /** @type {(inputs: Usage_Rate_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$2.00 प्रति कार्य`)
};

const pt_pt2_usage_rate_embed = /** @type {(inputs: Usage_Rate_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$ 2,00 por serviço`)
};

/**
* | output |
* | --- |
* | "$2.00 / job" |
*
* @param {Usage_Rate_EmbedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_rate_embed = /** @type {((inputs?: Usage_Rate_EmbedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Rate_EmbedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_rate_embed(inputs)
	if (locale === "de") return de_usage_rate_embed(inputs)
	if (locale === "it") return it_usage_rate_embed(inputs)
	if (locale === "ru") return ru_usage_rate_embed(inputs)
	if (locale === "es") return es_usage_rate_embed(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_rate_embed(inputs)
	if (locale === "ja") return ja_usage_rate_embed(inputs)
	if (locale === "hi") return hi_usage_rate_embed(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_rate_embed(inputs)
	return en_usage_rate_embed(inputs)
});